// extracted by mini-css-extract-plugin
export default {"arrow":"SliderArrow_arrow__isngV","arrowIcon":"SliderArrow_arrowIcon__vjRTw","nextArrow":"SliderArrow_nextArrow__225UA","prevArrow":"SliderArrow_prevArrow__sjMsB"};